import { jsx as o, jsxs as m } from "@emotion/react/jsx-runtime";
import { useMemo as g } from "react";
import { StyledTooltip as u, StyledTabButton as k, StyledChip as w, ChipContainer as j, StyledText as I } from "./Tab.styled.js";
import { Stack as d } from "../../Stack/index.js";
import { useTabsContext as A } from "../TabsContext.js";
const R = ({
  as: f,
  badge: c,
  children: h,
  className: y,
  counter: i,
  disabled: n = !1,
  onClick: b,
  onKeyDown: x,
  subtitle: l,
  tooltip: S,
  value: t,
  ref: C,
  ...T
}) => {
  const {
    selected: a,
    onChange: s
  } = A(), r = f ?? "button", p = g(() => t !== void 0 && a === t, [t, a]);
  return /* @__PURE__ */ o(u, { text: S, children: /* @__PURE__ */ o(k, { role: "tab", ref: C, className: y, as: r, "aria-label": t ? `${t}` : void 0, "aria-selected": p, "aria-disabled": n, disabled: r === "button" ? n : void 0, type: r === "button" ? "button" : void 0, onClick: (e) => {
    t !== void 0 && s(t), b?.(e);
  }, onKeyDown: (e) => {
    x?.(e), !e.defaultPrevented && !n && t && s(t);
  }, "data-is-selected": p, ...T, children: /* @__PURE__ */ m(d, { direction: "column", gap: "0.5px", children: [
    /* @__PURE__ */ m(d, { direction: "row", alignItems: "center", gap: "8px", children: [
      h,
      typeof i == "number" || typeof i == "string" ? /* @__PURE__ */ o(w, { dataTrackId: "", children: i }) : null,
      c ? /* @__PURE__ */ o(j, { children: c }) : null
    ] }),
    l ? /* @__PURE__ */ o(d, { direction: "row", children: /* @__PURE__ */ o(I, { as: "span", variant: "bodySRegular", color: "secondary", children: l }) }) : null
  ] }) }) });
};
export {
  R as Tab
};
